import React, { Component } from 'react';
import LoginContainer from './LoginContainer';
import MobileDownloadInfo from './MobileDownloadInfo';
import './Content.css';

const DOWNLOAD_INFO_TITLE = 'Need a Bitmoji?';
const DOWNLOAD_INFO_TEXT = 'Create your avatar using the Bitmoji mobile app on iOS and Android.';

class Content extends Component {
    render() {
        return (
            <div className="content">
                <LoginContainer />
                <MobileDownloadInfo title={DOWNLOAD_INFO_TITLE}
                                    text={DOWNLOAD_INFO_TEXT} />
            </div>
        );
    }
}

export default Content;



// WEBPACK FOOTER //
// ./src/components/login_view/Content.js